export default "__VITE_ASSET__maegS076__"